export class Persona {
    public nombreCompleto?: string;
    public fechaNacimiento?: string;
    public DNI?: string;
    public provincia: {code: '', name: ''}
    public vivienda: {cadastralCode: '', number: '', name: ''}
    public calle: {code: '',name: '',type: ''}
    public telefonoMovil?: Number;
    public municipio: {code: '', name: ''}
    public uuidPersona?: string;
    public nombre?: string;
    public email?: string;
    public idPersona?: string;
    public apellidos?: string;
    public idCotizacion?: string;
    public dni?: string;
    public primaTotal?: number;

    constructor(){
        this.municipio = {code: '', name: ''};
        this.vivienda = {cadastralCode: '', number: '', name: ''}
        this.provincia = {code: '', name: ''}
        this.calle = {code: '',name: '',type: ''};
    }
}